const GRID_VIEW_TO_MOBILE = { '2': '1', '3': '2', '4': '3' };

function applyGridDensity(view) {
  const collectionGrid = document.querySelector(".collection-grid");
  if (collectionGrid) {
    collectionGrid.setAttribute('data-desk', view);
    if (GRID_VIEW_TO_MOBILE[view]) collectionGrid.setAttribute('data-mb', GRID_VIEW_TO_MOBILE[view]);
  }
  document.querySelectorAll(".coll-view a").forEach((a) => {
    const isActive = a.getAttribute('data-view') === view;
    a.classList.toggle('active', isActive);
    a.classList.toggle('active-mb', isActive);
  });
}

(function restoreGridDensity() {
  const links = [...document.querySelectorAll(".coll-view a")];
  if (!links.length) return;

  const storedGrid = localStorage.getItem("collection_grid");
  const allowedViews = links.map(a => a.getAttribute('data-view'));
  if (storedGrid == null || !allowedViews.includes(storedGrid)) return;

  applyGridDensity(storedGrid);
})();

document.addEventListener("DOMContentLoaded", (event) => {
  const infoShort = document.querySelector('.coll-short-desc');
  const readBtn = document.querySelector('.coll-desc-read');
  if (infoShort && readBtn){
    const originalStyle = infoShort.style.cssText;
    infoShort.style.webkitLineClamp = 'unset';
    infoShort.style.display = 'block';
    const fullHeight = infoShort.scrollHeight;
    infoShort.style.cssText = originalStyle;
    const clampedHeight = infoShort.clientHeight;
    if (fullHeight <= clampedHeight) {
      readBtn.style.display = 'none';
    }
    readBtn.addEventListener('click', function(e) {
      e.preventDefault();
      infoShort.classList.toggle('active-full-desc');
      if (infoShort.classList.contains('active-full-desc')) {
        infoShort.style.webkitLineClamp = 'unset';
      } else {
        infoShort.style.webkitLineClamp = '2';
      }
    });
  }
  if(document.querySelector('.coll-desc-read')) document.querySelector('.coll-desc-read').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.coll-desc').classList.toggle('active-full-desc');
    if(document.querySelector('.coll-desc.active-full-desc')){
      document.querySelector('.coll-desc.active-full-desc').style.maxHeight = '';
    }
  });
  function collNavSlider(){
    let coll_nav_swiper = new Swiper(".coll-nav-slider", {
      loop: false,
      a11y: false,
      slidesPerView: "auto",
      resizeObserver: false,
    });
    const activeSlide = document.querySelector(".coll-nav-slider .swiper-slide.active");
    if (activeSlide) {
      const swiperWrapper = activeSlide.closest(".swiper-wrapper");
      const wrapperRect = swiperWrapper.getBoundingClientRect();
      const slideRect = activeSlide.getBoundingClientRect();
      const isInView =
        slideRect.left >= wrapperRect.left &&
        slideRect.right <= wrapperRect.right;
      if (!isInView) {
        const activeIndex = [...activeSlide.parentNode.children].indexOf(activeSlide);
        coll_nav_swiper.slideTo(activeIndex, 500);
      }
    }
  }
  collNavSlider();



  if (document.querySelectorAll('.coll-view a')){
    document.querySelectorAll('.coll-view a').forEach((grid) => {
      grid.addEventListener('click', function(e){
        e.preventDefault();
        const visibleProducts = [];
        document.querySelectorAll('.collection-grid .product-item').forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          if (rect.top >= 0 && rect.bottom <= window.innerHeight){
            visibleProducts.push(index);
          }
        });
        localStorage.setItem("collection_grid", grid.getAttribute('data-view'));
        applyGridDensity(grid.getAttribute('data-view'));
        requestAnimationFrame(() => {
          if (typeof initSliders === 'function') initSliders();
        });
        setTimeout(() => {
          if (visibleProducts.length > 0) {
            const scrollToIndex = Math.floor(visibleProducts.length / 2);
            const target = document.querySelectorAll('.collection-grid .product-item')[visibleProducts[scrollToIndex]];
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }, 300);
      });
    });
  }

  let pro_grid_filter = document.querySelector('.pro-grid-filter-btn');
  if(pro_grid_filter) pro_grid_filter.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.toggle('open-model');
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  });
  var pro_grid_filter_wrap = document.querySelector('.pro-grid-filter a');
  if(pro_grid_filter_wrap) pro_grid_filter_wrap.addEventListener('click',function(e){
    e.preventDefault();
    let main_id = pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').getAttribute('data-id');
    let current_id = pro_grid_filter_wrap.getAttribute('data-id');
    sessionStorage.setItem("col-view", current_id);
    pro_grid_filter_wrap.setAttribute('data-id',main_id);
    pro_grid_filter_wrap.textContent = main_id;
    pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').setAttribute('data-id',current_id);
    pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn .pro-grid-filter-value').textContent = current_id;
    document.querySelector('body').classList.remove('open-model');
    setTimeout(() => {
      callBack();
      quickAddButton();
    }, 100);
  });
  let session_val = sessionStorage.getItem("col-view");
  if(session_val != null){
    if(session_val == 'product'){
      var pro_grid_filter_wrap = document.querySelector('.pro-grid-filter a');
      pro_grid_filter_wrap.setAttribute('data-id','model');
      pro_grid_filter_wrap.textContent = 'model';
      pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn').setAttribute('data-id',session_val);
      pro_grid_filter_wrap.closest('.coll-media-view').querySelector('.pro-grid-filter-btn .pro-grid-filter-value').textContent = session_val;
    }
  }
});
// Back/forward restore for the infinite-scroll grid. When the browser can't serve the page from
// bfcache (common on desktop, where third-party unload handlers block it), it reloads with only
// page 1 and its native scroll restoration jumps to the footer/top. We keep the pages loaded by
// load_more in sessionStorage and rebuild the grid + scroll position ourselves.
const COLL_RESTORE_KEY = 'collection-scroll-restore';
const COLL_RESTORE_MAX_ENTRIES = 3;
// Params that don't change the grid. On Safari, Shopify bounces the reload through shop.app
// ("Shop user recognition") and comes back with ?_su_rec=…&_su_rec_id=…; ads/links add utm_* etc.
const COLL_RESTORE_IGNORED_PARAMS = /^(_|utm_)|^(fbclid|gclid|msclkid)$/;
let collectionRestore = null;
let collectionClickedItem = null;
let collectionRestoreTried = false;
let collectionLeaveState = null;

function collectionRestoreUrl() {
  let params = new URLSearchParams(window.location.search);
  [...params.keys()].forEach(key => {
    if (COLL_RESTORE_IGNORED_PARAMS.test(key)) params.delete(key);
  });
  let search = params.toString();
  return window.location.pathname + (search ? '?' + search : '');
}
function readCollectionRestore() {
  try {
    return JSON.parse(sessionStorage.getItem(COLL_RESTORE_KEY)) || {};
  } catch (e) {
    return {};
  }
}
function isHistoryNavigation() {
  let nav = performance.getEntriesByType('navigation')[0];
  return !!nav && (nav.type === 'back_forward' || nav.type === 'reload');
}
function gridItemHref(item) {
  let link = item.querySelector('.product-link') || item.querySelector('a[href]');
  return link ? link.getAttribute('href') : null;
}
function getGridAnchor(grid) {
  let items = [...grid.querySelectorAll('.product-item')];
  let inView = (el) => {
    let rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };
  let item = collectionClickedItem;
  if (!item || !grid.contains(item) || !inView(item)) item = items.find(inView);
  if (!item) return null;
  return { index: items.indexOf(item), href: gridItemHref(item), top: item.getBoundingClientRect().top };
}
function getRestoreScrollY(grid, state) {
  let anchor = state.anchor;
  if (anchor) {
    let items = [...grid.querySelectorAll('.product-item')];
    let item = (anchor.href && items.find(el => gridItemHref(el) === anchor.href)) || items[anchor.index];
    if (item) return item.getBoundingClientRect().top + window.scrollY - anchor.top;
  }
  return state.scrollY || 0;
}
function saveCollectionRestore() {
  let restore = collectionRestore;
  if (!restore || !restore.grid.isConnected) return;
  let url = collectionRestoreUrl();
  let entries = readCollectionRestore();
  entries[url] = collectionLeaveState = {
    time: Date.now(),
    pages: restore.pages,
    nextUrl: restore.nextUrl,
    scrollY: window.scrollY,
    anchor: getGridAnchor(restore.grid),
  };
  Object.keys(entries)
    .sort((a, b) => entries[b].time - entries[a].time)
    .slice(COLL_RESTORE_MAX_ENTRIES)
    .forEach(key => delete entries[key]);
  try {
    sessionStorage.setItem(COLL_RESTORE_KEY, JSON.stringify(entries));
  } catch (e) {
    // Quota exceeded: drop the other collections and keep only this one.
    try {
      sessionStorage.setItem(COLL_RESTORE_KEY, JSON.stringify({ [url]: entries[url] }));
    } catch (e2) {
      try { sessionStorage.removeItem(COLL_RESTORE_KEY); } catch (e3) {}
    }
  }
}
window.addEventListener('pagehide', saveCollectionRestore);
// Safari brings the page back from the back/forward cache scrolled to the top while scrollRestoration
// is 'manual' (Chrome keeps the position), so put it back from what we saved on pagehide.
window.addEventListener('pageshow', (e) => {
  let restore = collectionRestore;
  if (e.persisted && collectionLeaveState && restore && restore.grid.isConnected) {
    restoreCollectionScroll(restore.grid, collectionLeaveState);
  }
});
document.addEventListener('click', (e) => {
  let item = e.target.closest && e.target.closest('#product-grid .product-item');
  if (item) collectionClickedItem = item;
}, true);
function restoreCollectionScroll(grid, state) {
  let stop = new AbortController();
  let align = () => {
    if (grid.isConnected) window.scrollTo(0, getRestoreScrollY(grid, state));
  };
  // Keep re-aligning while late layout (fonts, sliders, banner images) settles, unless the user takes over.
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(type => {
    window.addEventListener(type, () => stop.abort(), { passive: true, signal: stop.signal });
  });
  align();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', align, { once: true, signal: stop.signal });
  }
  if (document.readyState !== 'complete') {
    window.addEventListener('load', () => { align(); stop.abort(); }, { once: true, signal: stop.signal });
  } else {
    stop.abort();
  }
}

function load_more(){
  let loadMoreBtn = document.querySelector('.load-more');
  let currentRowsLoaded = 2;
  let isLoading = false;
  let desktopPromoImages = document.querySelectorAll('.snippet-promo-image, .snippet-promo-text, .snippet-promo-media-row');
  let isMobile = window.innerWidth < 992;
  let mb = parseInt(document.querySelector('#product-grid').getAttribute('data-limit') / document.querySelector('#product-grid').getAttribute('data-mb'));
  let desk = parseInt(document.querySelector('#product-grid').getAttribute('data-limit') / document.querySelector('#product-grid').getAttribute('data-desk'));
  let rowsPerLoad = isMobile ? mb : desk;

  let productGrid = document.querySelector('#product-grid');
  let restore = collectionRestore = {
    grid: productGrid,
    pages: [],
    nextUrl: loadMoreBtn ? loadMoreBtn.getAttribute('href') : null,
  };
  // Appends the products/promos of a parsed page and returns their original markup for sessionStorage.
  let appendPageItems = (doc, animate) => {
    let pageHtml = '';
    doc.querySelectorAll('.collection-grid .product-item').forEach(product => {
      let productId = product.getAttribute('data-id');
      if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
        pageHtml += product.outerHTML;
        if (animate) {
          product.classList.add('init-loading-item');
          setTimeout(() => {
            product.classList.remove('init-loading-item');
          }, 100);
        }
        productGrid.appendChild(product);
      }
    });
    doc.querySelectorAll('.snippet-promo-image, .snippet-promo-text, .snippet-promo-media-row').forEach(promo => {
      let blockId = promo.getAttribute('data-block-id');
      if (blockId && !productGrid.querySelector(`[data-block-id="${blockId}"]`)) {
        pageHtml += promo.outerHTML;
        promo.style.display = '';
        productGrid.appendChild(promo);
      }
    });
    currentRowsLoaded += rowsPerLoad;
    return pageHtml;
  };
  let displayPromoImages = (promoImages, rowAttribute, delay) => {
    promoImages.forEach(promo => {
      let promoRow = parseInt(promo.getAttribute(rowAttribute), 10);
      if (promoRow <= currentRowsLoaded + rowsPerLoad && promo.style.display === 'none') {
        let show = () => {
          promo.style.display = 'block';
          productGrid.appendChild(promo);
        };
        delay ? setTimeout(show, delay) : show();
      }
    });
  };
  let revealPromoImages = (delay) => {
    let isMobileNow = window.innerWidth < 992;
    displayPromoImages(desktopPromoImages, isMobileNow ? 'data-mobile-row' : 'data-desk-row', delay);
  };
  let setNextPage = (url) => {
    restore.nextUrl = url || null;
    if (url) {
      loadMoreBtn.setAttribute('href', url);
    } else {
      document.querySelector('.coll-more-scroll')?.remove();
    }
  };
  let restoreLoadedPages = () => {
    if (collectionRestoreTried) return;
    collectionRestoreTried = true;
    if ((window.Shopify && Shopify.designMode) || !isHistoryNavigation()) return;
    let state = readCollectionRestore()[collectionRestoreUrl()];
    if (!state) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (loadMoreBtn && state.pages && state.pages.length) {
      let parser = new DOMParser();
      state.pages.forEach(pageHtml => {
        let doc = parser.parseFromString(`<div class="collection-grid">${pageHtml}</div>`, 'text/html');
        restore.pages.push(appendPageItems(doc, false));
      });
      revealPromoImages(0);
      setNextPage(state.nextUrl);
      // Only needed if this runs after the deferred scripts already initialised the grid.
      if (document.readyState !== 'loading') {
        if (typeof quickAddButton === 'function') quickAddButton();
        if (typeof $th_refreshWishlistItems === 'function') $th_refreshWishlistItems();
        if (typeof callBack === 'function') callBack(true);
      }
    }
    restoreCollectionScroll(productGrid, state);
  };
  let loadNextPage = () => {
    if (!loadMoreBtn || isLoading) return;
    let nextPageUrl = loadMoreBtn.getAttribute('href');
    if (!nextPageUrl) return;
    isLoading = true;
    if (document.querySelector('.coll-more-scroll')) {
      let parentElement = document.querySelector('.collection-grid');
      document.querySelectorAll('.blank-span').forEach(blankDiv => blankDiv.remove());
      let spanWrapper = document.createElement("span");
      spanWrapper.classList.add("blank-span");
      for(let i = 0; i < 6; i++){
        let child = document.createElement("span");
        spanWrapper.appendChild(child);
      }
      parentElement.appendChild(spanWrapper);
      document.querySelector('.coll-more-scroll').classList.add('loading');
    }
    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        // document.querySelectorAll('.blank-span').forEach(blankDiv => {
        //   blankDiv.remove();
        // });
        
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        let newProducts = doc.querySelectorAll('.collection-grid .product-item');
        let nextPaginationLink = doc.querySelector('.coll-more-scroll .load-more');

        // newProducts.forEach(product => {
        //   let productId = product.getAttribute('data-id');
        //   if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
        //     product.classList.add("loading"); // start with skeleton
        //     let img = product.querySelector("img");
        //     if (img) {
        //       img.addEventListener("load", () => {
        //         product.classList.remove("loading");
        //         product.classList.add("loaded");
        //       });
        //       // In case image is cached
        //       if (img.complete) {
        //         product.classList.remove("loading");
        //         product.classList.add("loaded");
        //       }
        //     }
        //     productGrid.appendChild(product);
        //   }
        // });
        
        // newProducts.forEach(product => {
        //   let productId = product.getAttribute('data-id');
        //   if (!document.querySelector(`.product-item[data-id="${productId}"]`)) {
        //     setTimeout(() => {
        //       productGrid.appendChild(product);
        //       product.classList.add('init-loading-item');
        //       setTimeout(() => {
        //         product.classList.remove('init-loading-item');
        //         if(!product.classList.contains('init-loading-item')){
        //           document.querySelector('.coll-more-scroll').classList.remove('loading');
        //         }
        //       }, 1000);
        //     }, 1000);
        //   }
        // });
        restore.pages.push(appendPageItems(doc, true));
        // The grid is now longer than what a plain reload renders, so we restore scroll ourselves on back.
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        if (newProducts.length > 0) {
          setTimeout(() => {
            document.querySelector('.coll-more-scroll')?.classList.remove('loading');
            if (typeof quickAddButton === 'function') {
              console.log('called');
              quickAddButton();
            }
          }, 600);
        }

        // for(let i = 0; i < parseInt(document.querySelector('.collection-grid').getAttribute('data-limit')); i++){
        //   let span = document.createElement("span");
        //   span.classList.add("blank-span");
        //   parentElement.appendChild(span);
        // }
        revealPromoImages(500);
        setNextPage(nextPaginationLink && nextPaginationLink.getAttribute('href'));

        $th_refreshWishlistItems();
        setTimeout(() => {
          callBack(true);
        }, 100);
      })
      .catch(err => console.error('Error loading products:', err))
      .finally(() => {
        isLoading = false;
      });
  };
  let observeLoadMoreBtn = () => {
    if (!loadMoreBtn) return;
    let observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px 500px 0px',
    };
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading) {
          loadNextPage();
        }
      });
    }, observerOptions);
    observer.observe(loadMoreBtn);
  };
  restoreLoadedPages();
  observeLoadMoreBtn();
}
load_more();
// Expose product card row height + row gap so full-width promo media can match 1 or 2 card rows on mobile
function syncCardRowHeight(){
  let wrapper = document.getElementById('collection-grid');
  if (!wrapper) return;
  let observedCard = null;
  let lastHeight = null;
  let lastGap = null;
  let update = () => {
    let grid = wrapper.querySelector('.collection-grid');
    if (!observedCard || !grid) return;
    let height = observedCard.offsetHeight + 'px';
    let gap = getComputedStyle(grid).rowGap;
    // Only write when changed, to avoid needless style recalcs
    if (height !== lastHeight) wrapper.style.setProperty('--card-row-h', lastHeight = height);
    if (gap !== lastGap) wrapper.style.setProperty('--card-row-gap', lastGap = gap);
  };
  let resizeObserver = new ResizeObserver(update);
  let observeCard = () => {
    let card = wrapper.querySelector('.collection-grid .product-item');
    if (card === observedCard) return;
    if (observedCard) resizeObserver.unobserve(observedCard);
    observedCard = card;
    if (card) resizeObserver.observe(card);
  };
  observeCard();
  // Filters replace the grid's markup (grid view toggles resize the card, which the ResizeObserver already catches)
  new MutationObserver(observeCard).observe(wrapper, { childList: true });
}
syncCardRowHeight();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#product-grid')) {
    load_more();
    syncCardRowHeight();
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const target = document.querySelector('.shopify-section-group-footer-group');
  if (!target) return;
  function toggleBodyClass() {
    const rect = target.getBoundingClientRect();
    const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
    document.body.classList.toggle('hide-sticky-filter', inViewport);
  }
  toggleBodyClass();
  window.addEventListener('scroll', toggleBodyClass);
  window.addEventListener('resize', toggleBodyClass);
});
document.addEventListener('shopify:block:select', (event) => {
  if (event.detail.load) return;
  let el = event.target.closest('.snippet-promo-image,.snippet-promo-text,.snippet-promo-media-row') || event.target;
  el.scrollIntoView({ block: 'center', behavior: 'smooth' });
});